<template>
  <c-card>
    <c-card-header>
      <slot name="header">
        <c-icon name="cil-grid" />
        {{ caption }}
      </slot>
    </c-card-header>
    <c-card-body>
      <c-data-table
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="small ? 10 : 5"
        :dark="dark"
        pagination
      >
        <template #status="{item}">
          <td>
            <c-badge :color="getBadge(item.status)">{{ item.status }}</c-badge>
          </td>
        </template>
      </c-data-table>
    </c-card-body>
  </c-card>
</template>

<script>
export default {
  name: 'Table',
  props: {
    items: Array,
    fields: {
      type: Array,
      default() {
        return ['username', 'registered', 'role', 'status'];
      },
    },
    caption: {
      type: String,
      default: 'Table',
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
  },
  methods: {
    getBadge(status) {
      return status === 'Active'
        ? 'success'
        : status === 'Inactive'
          ? 'secondary'
          : status === 'Pending'
            ? 'warning'
            : status === 'Banned'
              ? 'danger'
              : 'primary';
    },
  },
};
</script>
